{
  "list": {
    "title": "Cụm từ thông minh",
    "backToDashboard": "Bảng điều khiển",
    "newButton": "Cụm từ mới",
    "import": "Nhập",
    "export": "Xuất",
    "searchPlaceholder": "Tìm theo khóa hoặc văn bản mở rộng...",
    "filterAllCategories": "Tất cả danh mục",
    "header": "Cụm từ ({{count}})",
    "loading": "Đang tải cụm từ...",
    "empty": "Không tìm thấy cụm từ. Hãy tạo cụm từ thông minh đầu tiên của bạn.",
    "authoredBy": "bởi {{name}}",
    "tooltips": {
      "preview": "Xem trước",
      "edit": "Sửa",
      "delete": "Xóa"
    },
    "confirmDelete": "Xác nhận",
    "cancelDelete": "Hủy",
    "previewLabel": "Xem trước:",
    "closePreview": "Đóng xem trước",
    "toast": {
      "deleted": "Đã xóa cụm từ",
      "importComingSoon": "Chức năng nhập sẽ sớm có",
      "exportComingSoon": "Chức năng xuất sẽ sớm có"
    }
  },
  "form": {
    "editTitle": "Sửa cụm từ thông minh",
    "createTitle": "Cụm từ thông minh mới",
    "fields": {
      "key": "Khóa",
      "category": "Danh mục",
      "expansionText": "Văn bản mở rộng"
    },
    "required": "*",
    "keyPlaceholder": ".normalexam",
    "keyHelper": "Phải bắt đầu bằng \".\"",
    "categoryUncategorized": "Chưa phân loại",
    "expansionPlaceholder": "Nội dung sẽ thay thế lối tắt...",
    "cancel": "Hủy",
    "create": "Tạo cụm từ",
    "update": "Cập nhật cụm từ",
    "toast": {
      "created": "Đã tạo cụm từ",
      "updated": "Đã cập nhật cụm từ",
      "saveFailed": "Lưu cụm từ thất bại",
      "keyMustStartWithDot": "Khóa phải bắt đầu bằng \".\"",
      "keyTooShort": "Khóa phải có ít nhất 2 ký tự",
      "expansionRequired": "Văn bản mở rộng là bắt buộc"
    }
  },
  "category": {
    "general": "Tổng quát",
    "physicalExam": "Khám lâm sàng",
    "reviewOfSystems": "Khám theo cơ quan",
    "assessment": "Đánh giá",
    "plan": "Kế hoạch",
    "instructions": "Hướng dẫn",
    "medications": "Thuốc",
    "history": "Tiền sử"
  }
}
